"use strict";
var ToggleController = (function () {
    /* @ngInject */
    function ToggleController($timeout) {
        var _this = this;
        this.$timeout = $timeout;
        this.toggle = function () {
            _this.value = !_this.value;
            _this.onChange({ name: _this.name, value: _this.value });
        };
    }
    ToggleController.prototype.click = function () {
        if (this.debounce && !this.noToggleTimer) {
            this.debouncedToggle();
        }
        else if (!this.debounce) {
            this.toggle();
        }
    };
    ;
    ToggleController.prototype.getStyleClasses = function () {
        var classes = "";
        if (this.large !== void 0) {
            classes += "toggle--large ";
        }
        if (this.value) {
            classes += "toggle--on ";
        }
        if (this.value && this.large !== void 0) {
            classes += "toggle--on-large ";
        }
        return classes;
    };
    ToggleController.prototype.debouncedToggle = function () {
        var _this = this;
        this.toggle();
        this.noToggleTimer = this.$timeout(function () {
            _this.$timeout.cancel(_this.noToggleTimer);
            _this.noToggleTimer = void 0;
        }, this.debounce);
    };
    return ToggleController;
}());
exports.ToggleController = ToggleController;



/** WEBPACK FOOTER **
 ** ./app/common/toggle/toggle.controller.ts
 **/